import { alpha, makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      borderRadius: theme.shape.borderRadius,
      backgroundColor: COLORS.neutral.white,
      fontFamily: theme.typography.fontFamily,
      display: 'flex',
      flexFlow: 'column nowrap',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      padding: theme.spacing(2, 1.5),
      rowGap: theme.spacing(1.5),
      border: theme.shape.borderGray70,
      boxShadow: theme.shape.boxShadowNormal,
      pointerEvents: 'auto',

      '&:disabled': {
        borderColor: COLORS.gray.gray80,
        boxShadow: 'unset',

        '& $title': {
          color: COLORS.gray.gray50,
        },

        '& $description': {
          color: COLORS.gray.gray50,
        },

        '& $label': {
          color: COLORS.gray.gray50,
        },

        '& $customModelTag': {
          backgroundColor: alpha(COLORS.gray.gray80, 0.3),
          color: COLORS.gray.gray50,
        },
      },

      '&:not(:disabled)': {
        '&:hover': {
          borderColor: COLORS.gray.gray60,
          boxShadow: theme.shape.boxShadowMedium,
        },

        '&$selected': {
          borderColor: COLORS.primary.active,
          boxShadow: 'unset',
        },
      },
    },
    tooltip: {
      width: 203,
    },
    customTooltip: {
      maxWidth: 480,
    },
    selected: {},
    titleWrapper: {
      display: 'flex',
      flexFlow: 'row nowrap',
      alignItems: 'center',
      width: '100%',
    },
    presetTovIcon: {
      color: COLORS.gray.gray30,
      marginRight: theme.spacing(1),
      fontSize: theme.typography.pxToRem(20),
    },
    title: {
      textAlign: 'left',
      color: COLORS.gray.black,
      maxWidth: '100%',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: 'block',
    },
    grayText: {
      color: COLORS.gray.gray40,
    },
    actionButton: {
      fontWeight: theme.typography.fontWeightMedium,
    },
    description: {
      color: COLORS.gray.black,
      maxWidth: '100%',
      textAlign: 'left',
    },
    draftActions: {
      display: 'flex',
      alignItems: 'center',
      marginTop: 'auto',
      columnGap: theme.spacing(0.5),
    },
    bullet: {
      color: COLORS.gray.gray50,
    },
    footer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginTop: 'auto',
      width: '100%',
    },
    label: {
      color: COLORS.gray.gray50,
      textAlign: 'left',
      display: 'flex',
      alignItems: 'center',
    },
    presetLabel: {
      width: '100%',
      '&:hover': {
        color: COLORS.gray.gray30,
      },
    },
    draftTag: {
      backgroundColor: COLORS.gray.gray80,
      color: COLORS.gray.gray40,
      textTransform: 'unset',
      padding: theme.spacing(0.25, 0.75),
      ...theme.typography.medium12,
    },
    customModelTag: {
      backgroundColor: COLORS.warning.light,
      textTransform: 'unset',
      padding: theme.spacing(0.25, 0.75),
      ...theme.typography.medium12,
    },
    disabledOverlay: {
      width: '100%',
      height: '100%',
      position: 'absolute',
      top: 0,
      left: 0,
      backgroundColor: alpha(COLORS.gray.background, 0.4),
    },
  }),
  { name: 'ToneOfVoiceCard' }
);
